import {useMediaQuery} from '@dnhb/node_package';
import defaultTheme from "../../../shared/defaultTheme";
import {useSelector} from "react-redux";
import {RootState} from "../redux/store";

const useMedia = (): {[key: string]: any} => {
  const {small, mobile, tablet} = useSelector((state: RootState) => {
    const {theme} = state.application;
    const {small, mobile, tablet} = theme;

    return {
      small,
      mobile,
      tablet
    }
  });

  const onSmallMobile = useMediaQuery(small || '(max-width: 479px)');
  const onMobile = useMediaQuery(mobile || defaultTheme.mobile);
  const onTablet = useMediaQuery(tablet || defaultTheme.tablet);

  return {onSmallMobile, onMobile, onTablet};
};

export default useMedia;
